import template from './contact-expert-success.html';
import './contact-expert-success.less';
import ContactExpertSuccessController from './contact-expert-success.controller';

const ContactExpertSuccessComponent = {
  bindings: {},
  template,
  controller: ContactExpertSuccessController
};

export default ContactExpertSuccessComponent;




// WEBPACK FOOTER //
// ./src/components/contact-expert-success/contact-expert-sucess.component.js